import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { Router } from "@angular/router";
import { k } from "src/environments/properties";
import { WebsocketService } from "src/app/core/services/websocket.service";
import { lastValueFrom, Subscription } from "rxjs";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { LoteService } from "src/app/core/services/lote.service";
import { AuthService } from "src/app/core/services/AuthService";
import { HttpHeaders } from "@angular/common/http";
import { DownloadService } from "src/app/core/services/download.service";
import { driver } from "driver.js";
import { HelpToursService } from "src/app/core/tours/help-tours.service";
import { FirmaUtils } from "src/app/core/utils/firma.utils";
import Swal from "sweetalert2";
import { ShareService } from "src/app/core/services/share.service";

// Tipo solo de ejemplo
interface ResumenAvanceFirma {
  cantidad_total: number;
  cantidad_firmada: number;
  // ...
}
@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"],
})
export class DashboardComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild("modalGruposResumenes") modalGruposResumenes!: TemplateRef<any>;
  @ViewChild("modalDescargaDocumento")
  modalDescargaDocumento!: TemplateRef<any>;

  isActiveCollapsed = false; // abierto por defecto
  isEndedCollapsed = true; // cerrado por defecto

  isGroupCollapsed = false;
  isLastDocsCollapsed = false;
  isDocsWithRetries = false;

  lotesPorFirmar: any[] = [];
  lotesFirmados: any[] = [];
  lotesGestionar: any[] = [];
  lotesReintentos: any[] = [];

  lotesReintentosDetalles: any[] = [];

  userToken: string = "";
  userId: any;

  totalItemsLotesPorFirmar: any = 0;
  totalItemslotesFirmados: any = 0;
  totalItemsLotesGestionar: any = 0;
  totalItemsReintentos: any = 0;
  modalResumenIsOpen: boolean = false;

  resumenAvanceFirma: any[] = [];
  loteSelected: any;

  firmaUtils = FirmaUtils;

  constructor(
    private websocketService: WebsocketService,
    private router: Router,
    private modalService: NgbModal,
    private loteService: LoteService,
    private authService: AuthService,
    private downloadService: DownloadService,
    private tours: HelpToursService,
    private shareService: ShareService,
  ) {}

  ngAfterViewInit(): void {
    this.onHelp();
  }

  getProgress(resumen: ResumenAvanceFirma): number {
    if (!resumen.cantidad_total || resumen.cantidad_total === 0) {
      return 0;
    }

    return (resumen.cantidad_firmada / resumen.cantidad_total) * 100;
  }

  onHelp(force = false) {
    this.tours.start("dashboard_help", force);
  }

  testDriver() {
    const d = driver({
      stagePadding: 8,
      stageRadius: 10,
      showProgress: true,
    });

    d.setSteps([
      {
        element: "#btnCrearLote",
        popover: {
          title: "Guía rápida",
          description: "Te mostraremos brevemente cómo usar el sistema.",
        },
      },
    ]);

    d.drive();
  }

  onDocumentoClick(itemLote: any) {
    this.loteSelected = itemLote;
    this.openModal(this.modalDescargaDocumento);
  }

  compartirDocumento() {
    this.shareService.shareDocument({
      title: "Documento",
      text: "Te comparto este documento",
      url: "https://miapp.com/documentos/123",
    });
  }

  async compartirPdf() {
    const response = await fetch(
      "https://s2.q4cdn.com/175719177/files/doc_presentations/Placeholder-PDF.pdf",
    );
    const blob = await response.blob();

    const file = new File([blob], "documento.pdf", {
      type: "application/pdf",
    });

    await this.shareService.shareDocument({
      title: "Documento PDF",
      text: "Te comparto este documento",
      file,
    });
  }

  onDocumentoLongPress(doc: string) {}

  async onGrupoClick(lote: any) {
    this.loteSelected = lote;
    let stats = await lastValueFrom(
      this.loteService.getResumenFirma(lote?.id, null),
    );
    if (stats?.body && !this.modalResumenIsOpen) {
      this.modalResumenIsOpen = true;
      this.resumenAvanceFirma = stats.body;

      this.openModal(this.modalGruposResumenes);
    }
  }

  async openModalReintentos(modalReference: any, lote: any) {
    this.loteSelected = lote;
    let detalle = await lastValueFrom(
      this.loteService.getReintentosDetalleByLote(lote.id, 1, 100, "FAL"),
    );
    if (detalle?.body) {
      this.lotesReintentosDetalles = detalle?.body;
    }
    this.openModal(modalReference);
  }

  onGrupoLongPress(doc: string) {}

  openModal(content: any) {
    const modalRef = this.modalService.open(content, {
      centered: true,
      size: "lg",
    });

    this.modalResumenIsOpen = true;

    modalRef.result
      .then((result) => {
        // cierre normal (modal.close)
        this.modalResumenIsOpen = false;
      })
      .catch((reason) => {
        // cerrado con X, ESC o backdrop
        this.modalResumenIsOpen = false;
      });
  }

  private newUserSubscription: Subscription; // Para el evento 'newUserCreated'
  public contratoEstadoMensaje: any;
  public mensajeNuevoUsuario: string = "";

  public user_name: any;

  async ngOnInit() {
    this.user_name = localStorage.getItem(k.user_name);
    this.userToken = localStorage.getItem(k.token);

    if (this.userToken) {
      const dataUser = await this.authService.dataUser(this.userToken);
      this.userId = dataUser.id;
      await this.getLotesPendientes();
      await this.getLotesCompletados();
      await this.getPorFirmar();
      await this.getLotesReintentos();
    }
  }

  async getLotesPendientes() {
    let data = await lastValueFrom(
      this.loteService.getLotes(1, 5, this.userId, "SDF"),
    );
    const headers: HttpHeaders = data.headers;
    this.lotesGestionar = data.body;
    this.totalItemsLotesGestionar = Number(headers.get("X-Total-Count"));
  }

  async getLotesReintentos() {
    let data = await lastValueFrom(
      this.loteService.getLotesReintentos({ estado_short_name: "FAL" }),
    );
    const headers: HttpHeaders = data.headers;
    this.lotesReintentos = data.body;
    this.totalItemsReintentos = Number(headers.get("X-Total-Count"));
  }

  async crearReintento(loteDetalle: any) {
    Swal.fire({
      title: "¿Quieres reintentar este proceso de firma?",
      text: "Confirma para poder reintentar este proceso de firma",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí",
      cancelButtonText: "No",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let { lote_id, scratchcard } = loteDetalle;
        await lastValueFrom(
          this.loteService.crearReintento(lote_id, { scratchcard }),
        );
        await this.getLotesReintentos();
        this.modalService.dismissAll();
      }
    });
  }

  async getLotesCompletados() {
    let data = await lastValueFrom(
      this.loteService.getLotes(1, 5, this.userId, "COMP"),
    );
    const headers: HttpHeaders = data.headers;
    this.lotesFirmados = data.body;
    this.totalItemslotesFirmados = Number(headers.get("X-Total-Count"));
  }

  async getPorFirmar() {
    let data = await lastValueFrom(this.loteService.getPorFirmar(1, 7));
    const headers: HttpHeaders = data.headers;
    this.lotesPorFirmar = data.body;
    this.totalItemsLotesPorFirmar = Number(headers.get("X-Total-Count"));
  }

  ngOnDestroy(): void {
    this.tours.stop();
  }

  async descargarZipPorLote() {
    let id = this.loteSelected.id;
    let nameZip = this.loteSelected.titulo;

    this.downloadService
      .descargarZipPorLote(id, "mis_documentos")
      .subscribe((blob: Blob) => {
        const fileName = `${nameZip}.zip`; // o el que quieras
        const a = document.createElement("a");
        const objectUrl = URL.createObjectURL(blob);
        a.href = objectUrl;
        a.download = fileName;
        a.click();
        URL.revokeObjectURL(objectUrl);
      });
  }

  rederic(modulo: string) {
    switch (modulo) {
      case "firma":
        this.router.navigate(["firmas/admin-lotes"]);

        break;
      case "plantilla":
        this.router.navigate(["firmas/admin-plantillas"]);
        break;
      case "perfil":
        this.router.navigate(["perfil/perfil"]);
        break;

      case "firmantes":
        this.router.navigate(["firmas/firmantes"]);
        this.modalService.dismissAll();
        break;

      default:
        this.router.navigate([modulo]);
        this.modalService.dismissAll();
        break;
    }
  }

  onReload() {
    this.getLotesReintentos();
  }

  formatFechaLocalSinUTC(iso: string): string {
    // Quitamos la Z y los milisegundos
    const limpia = iso.replace("Z", "").split(".")[0];

    const d = new Date(limpia);

    const pad = (n: number) => n.toString().padStart(2, "0");

    return (
      `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ` +
      `${pad(d.getHours())}:${pad(d.getMinutes())}`
    );
  }
}
